import React, { useState } from "react";
import { handleEventInfoData } from "../../utils/storeConverter";
import { fireActionTriggerCustomEvent } from "../../utils/adobe-launch";
import "./MyBooks.css";

import ExitActivityButton from "../UI/Button/ExitActivityButton";
import storeTitleImage from "../../assets/hero/header.png";

function MyBooks({ handleDisposePlayer, storeId, books, activity }) {
  const [bookNum, setBookNum] = useState(0);
  const [isBookExcerpt, setIsBookExcerpt] = useState(false);

  const handleBookNum = (newBookNum) => {
    setBookNum((bookNum) => newBookNum);
  };

  const handleBookExcerpt = (newBookNum) => {
    setIsBookExcerpt((isBookExcerpt) => !isBookExcerpt);
    handleBookNum(newBookNum);
  };

  const BookExcerpt = ({ file }) => (
    <div className="backgroundDiv">
      <ExitActivityButton activity={activity} storeId={storeId} />
      {/* title image */}
      <img
        className="bookShelfImage"
        src={storeTitleImage}
        alt="The Book Shelf"
      />
      {/* book title outer container */}
      <div className="excerptContainerOuter">
        <div className="bookTitleOuterContainer">
          {/* book title inner container "Courtney Book" */}
          <h2 className="bookTitleInnerContainer">Courtney Book</h2>
        </div>
        <div className="excerptContainerInner">
          {/* book cover image */}
          <img className="bookCoverImage" src={file.cover} alt="Book Cover" />
          <div className="bookContent">
            {/* book title */}
            {/* <h2 className="bookTitle">{file.title}</h2> */}
            {/* excerpt text */}
            <div className="sentenceContainer">
              {file.summery.map((sentence, index) => (
                <p key={`section: ${index}`} className="sentence">
                  {sentence}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const Book = ({ file, allBooks, changeBookNum, changeIsExcerpt }) => (
    <div className="backgroundDiv">
      <ExitActivityButton activity={activity} storeId={storeId} />
      <div className="booksSection">
        <figure className="book">
          <ul className="hardcover_front">
            <li>
              <img src={allBooks[0].cover} alt={`${allBooks[0].title} Book Cover`} />
            </li>
            <li></li>
          </ul>
          <ul className="page">
            <li></li>
            <li>
              <a
                style={{ cursor: "pointer" }}
                onClick={ (e) => {
                  changeIsExcerpt(0);
                  handleEventInfoData({
                    storeName: window.digitalData.pageInfo.page_name,
                    page_name:
                      window.digitalData.pageInfo.page_name + `:open ${activity}`,
                    location_name: `Courtney tour`,
                  });
                  console.log("[next click event] ", window.digitalData);
                  fireActionTriggerCustomEvent(
                    e.target,
                    window.digitalData.event
                  );
                }}
                className="btn"
              >
                {allBooks[0].insideText}
              </a>
            </li>
            <li></li>
            <li></li>
            <li></li>
          </ul>
          <ul className="hardcover_back">
            <li></li>
            <li></li>
          </ul>
          <ul className="book_spine">
            <li></li>
            <li></li>
          </ul>
        </figure>

        <figure className="book">
          <ul className="hardcover_front">
            <li>
              <img src={allBooks[1].cover} alt={`${allBooks[1].title} Book Cover`} />
            </li>
            <li></li>
          </ul>
          <ul className="page">
            <li></li>
            <li>
              <a
                style={{ cursor: "pointer" }}
                onClick={ (e) => {
                  changeIsExcerpt(1);
                  handleEventInfoData({
                    storeName: window.digitalData.pageInfo.page_name,
                    page_name:
                      window.digitalData.pageInfo.page_name + `:open ${activity}`,
                    location_name: `Courtney tour`,
                  });
                  console.log("[next click event] ", window.digitalData);
                  fireActionTriggerCustomEvent(
                    e.target,
                    window.digitalData.event
                  );
                }}
                className="btn"
              >
                {allBooks[1].insideText}
              </a>
            </li>
            <li></li>
            <li></li>
            <li></li>
          </ul>
          <ul className="hardcover_back">
            <li></li>
            <li></li>
          </ul>
          <ul className="book_spine">
            <li></li>
            <li></li>
          </ul>
        </figure>
      </div>
    </div>
  );
  return (
    <div id="bookBackground">
      <div className="bookGallery">
        {isBookExcerpt ? (
          <BookExcerpt file={books[bookNum]} />
        ) : null}
      </div>
        {isBookExcerpt ? null : (
          <Book
            className="book"
            file={books[bookNum]}
            allBooks={books}
            changeBookNum={handleBookNum}
            changeIsExcerpt={handleBookExcerpt}
          />
        )}
    </div>
  );
}

export default MyBooks;
